import React from "react";


export default function LoadingModal({ text = "Loading..." }) {
return (
<div className="loading-modal">
<div className="loading-content">
<div className="loader" />
<p>{text}</p>
</div>
</div>
);
}